//export const BASE_URI = "https://localhost:5001";
// Le port 5000 est d�j� defini dans API.Program.cs => L'activer dans API/Propri�t�s/Build/Definir la constante DEBUG
export const BASE_URI = process.env.NODE_ENV === "production" ?  window.location.origin + "/api" : window.location.origin.replace('3000','5000');
